import styled, { DefaultTheme } from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import ActionButton from '@westwing/ui-kit/ActionButton';
import Media from '@ids/components/Media';
import Text from '@ids/components/Typography/Text';
import DefaultHeading from '@ids/components/Typography/Heading';

export const OverstepContainer = styled.section`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
`;

export const BackgroundImage = styled(Media.Image)`
    ${forTablet`
        object-fit: cover !important;
        object-position: top;
    `}
    object-position: top left;
    z-index: -1;
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: min(5%, 60px) min(5%, 20px);
    z-index: 1;
`;

export const ContentText = styled(Text)`
    max-width: 392px;

    text-align: center;
    margin: 1em auto;
`;

export const CTAContainer = styled.div`
    width: 100%;
    max-width: 392px;
    display: flex;
    flex-direction: column;

    & > * {
        margin: 0.33em 0;
    }
`;

export const CartButton = styled(ActionButton).attrs({ kind: 'primary', 'data-testid': 'overstep-cta-cart' })``;

export const StartoverButton = styled(ActionButton).attrs({
    kind: 'secondary',
    'data-testid': 'overstep-cta-startover',
})`
    background: ${({ theme }: { theme: DefaultTheme }) => theme.colors.white};

    &:hover,
    &:focus {
        background: ${({ theme }: { theme: DefaultTheme }) => theme.colors.charcoal10};
    }
`;

export const Heading = styled(DefaultHeading)`
    text-align: center;
`;
